import makeStyles from "@material-ui/core/styles/makeStyles";
import { useI18n } from "../../hooks";

interface DonatedSoFarProps {
	donatedSoFar: string;
	isAsso?: boolean;
}

const DonatedSoFar: React.FC<DonatedSoFarProps> = ({ donatedSoFar, isAsso = false }) => {

	const b = useI18n(i => i.am.banner);

	const classes = useStyles();

	return <div className={classes.container}>
		<div className='donated-so-far'>{b.donatedSoFar} {donatedSoFar} {b.shekel}</div>
		<div className={classes.nonFinalText}>{b.nonFinalSum}</div>
	</div>
}

export default DonatedSoFar;

const useStyles = makeStyles({
	container: {
		display: 'flex',
		flexDirection: 'column'
	},
	nonFinalText: {
		fontSize: '1rem'
	}
})